import { HttpErrorResponse } from '@angular/common/http';
import { CONSTANT } from '../../constant/constant';
import * as MSG from '../share/msg/msg';

export interface ErrorMessageInfo {
  message: string;
  toasterType: 'warning' | 'error' | 'important-warning';
}

export class HttpStatusCodes {
  public static getErrorMessageInfo: (error: any) => ErrorMessageInfo = (error: any) => {
    const info: ErrorMessageInfo = {
      message: MSG.DANGER.S500_INTERNAL_SERVER_ERROR,
      toasterType: 'error',
    };
    if (error instanceof HttpErrorResponse) {
      // エラー捕捉時の処理('error'に捕捉したエラー内容が格納されている)
      switch (error.status) {
      case 400:
        if (error.error.user_message) {
          info.message = MSG.DANGER.S400_BAD_REQUEST(error.error.user_message);
          break;
        } else if (error.error.error_message !== '') {
          switch (error.error.error_code) {
            case CONSTANT.API_ERROR_CODE.BAD_DATA_FOUND_IN_CSV:
              info.message = error.error.error_message;
              info.toasterType = 'important-warning';
              break;
            case CONSTANT.API_ERROR_CODE.LACKING_VALUE_CSV:
              info.message = error.error.error_message;
              info.toasterType = 'important-warning';
              break;
            case CONSTANT.API_ERROR_CODE.OVER_LIMIT_CSV_ROW:
              info.message = error.error.error_message;
              info.toasterType = 'warning';
              break;
            case CONSTANT.API_ERROR_CODE.OVER_LIMIT:
              info.message = error.error.error_message;
              info.toasterType = 'warning';
              break;
            case CONSTANT.API_ERROR_CODE.RSV_CONSISTENCY:
              info.message = error.error.error_message;
              info.toasterType = 'important-warning';
              break;
            case CONSTANT.API_ERROR_CODE.SUB_RSV_CONSISTENCY:
              info.message = error.error.error_message;
              info.toasterType = 'important-warning';
              break;
            default:
              info.message = error.error.error_message;
              info.toasterType = 'warning';
              break;
          }
          break;
        }
        info.message = MSG.DANGER.CONNECTION_FAILD;
        break;

      case 401:
        info.message = MSG.DANGER.S401_UNAUTHORIZED;
        break;

      case 402:
          if (error.error.error_message !== '') {
            info.message = error.error.error_message;
            info.toasterType = 'warning';
            break;
          } else {
            info.message = MSG.DANGER.S404_NOTFOUND;
            info.toasterType = 'warning';
          }
        break;

      case 403:
        info.message = MSG.DANGER.S403_FORBIDDEN;
        break;

      case 404:
        if (error && error.error && error.error.error_message !== '') {
          switch (error.error.error_code) {
            case CONSTANT.API_ERROR_CODE.NOT_FOUNDED_USERNAME:
              info.message = MSG.WARNING.NOT_EXIST_DATA('ご指定のusername');
              info.toasterType = 'warning';
              break;
            case CONSTANT.API_ERROR_CODE.NOT_FOUNDED_FELICA:
              info.message = MSG.WARNING.NOT_EXIST_DATA('ご指定のID');
              info.toasterType = 'warning';
              break;
            default:
              info.message = error.error.error_message;
              info.toasterType = 'warning';
              break;
          }
          break;
        } else {
          info.message = MSG.DANGER.S404_NOTFOUND;
          info.toasterType = 'warning';
        }
        break;

      case 409:
        if ([
            CONSTANT.API_ERROR_CODE.DUPLICATED_PERIOD,
            CONSTANT.API_ERROR_CODE.OVER_REGISTERATION_LIMIT,
            CONSTANT.API_ERROR_CODE.CONFLICT_WITH_OTHER_TERMINAL,
            CONSTANT.API_ERROR_CODE.CONFLICT_DUE_TO_ANGULAR_HAS_OLD_DATA,
            ].includes(error.error.error_code)) {
          info.message = error.error.error_message;
          info.toasterType = 'important-warning';
          break;
        }
        info.message = MSG.DANGER.S409_CONFLICT;
        break;

      case 415:
        if (error.error.user_message) {
          info.message = MSG.DANGER.S415_UNSUPPORTED_MEDIATYPE(error.error.user_message);
        }
        info.message = MSG.DANGER.CONNECTION_FAILD;
        break;

      case 500:
        info.message = MSG.DANGER.S500_INTERNAL_SERVER_ERROR;
        break;

      case 504:
        info.message = MSG.DANGER.S504_GATEWAY_TIMEOUT;
        break;

      case 0:
        info.message = MSG.DANGER.S0;
        info.toasterType = 'warning';
        break;
      default:
        console.log(error);
        break;
      }
    }
    return info;
  }
}
